import {
  KnownNotificationDtoChannel,
  KnownNotificationDtoLatestStatus,
  NotificationDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { forwardRef, useState } from 'react';
import { mapDeliveryNotificationToColor, mapDeliveryNotificationToIcon } from '../../deliveries/deliveries.constants';
import { useDeliveriesRequiringAttentionTooltipStyles } from '../../reports/deliveries-requiring-attention/list/components/deliveries-requiring-attention-tooltip.styles';
import { Tooltip } from '../../../ui/components/pure/tooltip/tooltip';

export interface NotificationProps {
  notification: NotificationDto;
  iconSize?: string;
  tooltip?(): JSX.Element;
  hideTooltip?: boolean;
}

export function Notification({ tooltip, hideTooltip, ...rest }: NotificationProps) {
  const [open, setOpen] = useState(false);

  // If no tooltip has been provided then use the default tooltip
  if (!tooltip) tooltip = () => <span>Notification</span>;

  const classes = useDeliveriesRequiringAttentionTooltipStyles({});

  return (
    <Tooltip
      open={open && !hideTooltip}
      onOpen={() => setOpen(true && !hideTooltip)}
      onClose={() => setOpen(false)}
      classes={{ tooltip: classes.tooltip }}
      title={tooltip()}
      width={'320px'}
    >
      <NotificationChildren {...rest} />
    </Tooltip>
  );
}

// The MUI tooltip requires that its ref and child props (it adds props to its children) are passed down to the native element being rendered
// This forward ref does this, while extracting the custom component props from the props before forwarding them to prevent React errors
const NotificationChildren = forwardRef<HTMLDivElement, Omit<NotificationProps, 'tooltip'>>(
  function NotificationChildren({ notification, iconSize, ...rest }, ref) {
    const SVG = mapDeliveryNotificationToIcon[notification.channel as KnownNotificationDtoChannel];
    const color = mapDeliveryNotificationToColor[notification.latestStatus as KnownNotificationDtoLatestStatus];

    if (!SVG) {
      return <></>;
    }
    return (
      <div {...rest} ref={ref}>
        <SVG
          key={notification.id}
          style={{
            width: iconSize ? iconSize : '34px',
            height: iconSize ? iconSize : '34px',
            color,
            marginRight: '3px'
          }}
        />
      </div>
    );
  }
);
